var map = {
	"./KEC Stidents Won First Prize form Education Minister.jpg": 60377,
	"./WhatsApp Image 2025-09-21 at 9.05.15 PM.jpeg": 23348,
	"./WhatsApp Image 2025-10-07 at 3.43.54 PM (1).jpeg": 55225,
	"./WhatsApp Image 2025-10-07 at 3.43.54 PM (2).jpeg": 68814,
	"./WhatsApp Image 2025-10-07 at 3.43.54 PM.jpeg": 83123,
	"./aids,mts.jpeg": 10837,
	"./chemical.jpeg": 26836,
	"./chemical1.jpeg": 91923,
	"./civil&ai.PNG": 15961,
	"./ece (2).jpg": 26857,
	"./ece.jpg": 99718,
	"./it.jpg": 11584,
	"./kpitsparkle2024.png": 19503,
	"./mts.jpg": 13209,
	"./mts1.jpg": 23976,
	"./mts2.jpg": 34903,
	"./sih2024.jpg": 40631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4679;